import { useCallback } from "react";

import { type ReferencedNodeValue } from "@doitintl/cmp-models";
import { Stack } from "@mui/material";
import { useFormikContext } from "formik";

import { cloudflowTexts } from "../../../../../../assets/texts";
import { ReferencedFieldStandalone } from "../../../ApiActionParametersForm/parameters/wrappers/ReferencedField/ReferencedFieldStandalone";
import { type NodeWitOutputModel } from "../../../ApiActionParametersForm/parameters/wrappers/ReferencedField/useReferencedFieldContext";
import { useFieldCommonProps } from "../../../ApiActionParametersForm/useFieldCommonProps";
import { FieldSectionHeader } from "../../../Common/FieldSectionHeader";
import { type DateTimeSchema } from "./schema";

export const NodeDataSourceForm = ({ referenceableNodes }: { referenceableNodes: NodeWitOutputModel[] }) => {
  const { getFieldProps, setValues } = useFormikContext<DateTimeSchema>();

  const referencedNodeFieldCommonProps = useFieldCommonProps(
    getFieldProps("referencedNodeField"),
    cloudflowTexts.REFERENCED_FIELD,
    true
  );

  const onReferencedNodeFieldChange = useCallback(
    (event: { target: { name: string; value: ReferencedNodeValue } }) => {
      setValues((values) => ({
        ...values,
        referencedNodeField: event.target.value ?? {
          referencedField: [],
          referencedNodeId: "",
        },
      }));
    },
    [setValues]
  );

  return (
    <Stack
      spacing={2}
      sx={{
        mb: 3,
      }}
    >
      <FieldSectionHeader
        title={cloudflowTexts.SELECT_FIELD_TO_TRANSFORM}
        subtitle={cloudflowTexts.DATA_WILL_BE_PASSED_DOWN_THE_FLOW}
      />
      <ReferencedFieldStandalone
        {...referencedNodeFieldCommonProps}
        onChange={onReferencedNodeFieldChange}
        referenceableNodes={referenceableNodes}
      />
    </Stack>
  );
};

export default NodeDataSourceForm;
